// 날짜: 2026.10.30.fri
export const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const weekday = date.toLocaleDateString('en-US', { weekday: 'short' }).toLowerCase();

    return `${year}.${month}.${day}.${weekday}`;
};

// 시간: pm 08:00:00 (분리된 형태)
export const formatTime = (date: Date) => {
    const hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    const ampm = hours >= 12 ? 'pm' : 'am';
    const displayHours = String(hours % 12 || 12).padStart(2, '0');

    return {
        ampm,
        time: `${displayHours}:${minutes}:${seconds}`
    };
};

// 마스트헤드: 10.30.2026 / 16:07 KST (feed와 같은 표기, 항상 서울 시각)
export const formatSeoulStamp = (date: Date) => {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Asia/Seoul',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).formatToParts(date);
    const value = (type: string) => parts.find((part) => part.type === type)?.value ?? '';

    return `${value('month')}.${value('day')}.${value('year')} / ${value('hour')}:${value('minute')} KST`;
};
